<div
  class="flex flex-row bg-white hover:bg-gray-50 border-1 border-solid object-cover w-full rounded-[6px] cursor-pointer"
  [ngClass]="{ 'border-red-500': !isFileValid() }"
  *transloco="let t"
>
  <div class="flex flex-col mx-2 my-3">
    <mat-icon class="mat-icon-outlined text-[32px] size-[32px] text-red-500">file_present</mat-icon>
  </div>
  <div class="flex flex-1 flex-col gap-1 my-2">
    <h3 class="text-sm font-semibold">{{ fileName() }}</h3>
    <small class="text-xs font-normal palette-text-64">
      {{ t('attachment.size') }}: {{ fileSize() | bytesToUnit: SizeUnit.MB }}
    </small>
  </div>
  <div class="flex flex-row items-center gap-1 mr-2">
    @if (fileUrl()) {
      <a mat-icon-button class="flex justify-center align-center" [href]="fileUrl()" [download]="fileName()">
        <mat-icon class="mat-icon-outlined text-[19px] size-[19px] mt-[2px]">download</mat-icon>
      </a>
    }
    <button mat-icon-button class="flex justify-center align-center" (click)="removeFileClick()">
      <mat-icon class="mat-icon-outlined text-[19px] size-[19px] mt-[2px]">delete</mat-icon>
    </button>
  </div>
</div>
